<tec-tile
	[id]="OPERATION_TYPE.ATTORNEY_POWERS"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon"
>
	<tec-tile
		[title]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_METHOD' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_METHOD_DESCRIPTION' | translate"
	>
		<div class="grid grid-i2">
			<tec-card-select
				[tagImg]="{ icon: 'icon-AI', status: 'notice' }"
				[title]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_AUTO' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_AUTO_DESCRIPTION' | translate"
				[selected]="mode === 'auto'"
				(selectedChange)="setMode('auto', $event)"
			/>
			<tec-card-select
				[tagImg]="{ icon: 'icon-file', status: 'control' }"
				[title]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_MANUAL' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_MANUAL_DESCRIPTION' | translate"
				[selected]="mode === 'manual'"
				(selectedChange)="setMode('manual', $event)"
			/>
		</div>

		@if (mode === 'auto') {
			<tec-form-group
				[label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_DESCRIPTION' | translate"
			>
				<tec-toggle
					[options]="[
						{
							id: 'manual',
							label: 'WORKFLOWS.FORM.OPERATIONS.BUTTON_ADD_ATTORNEY_POWERS' | translate,
						},
						{
							id: 'auto',
							label: 'WORKFLOWS.FORM.OPERATIONS.FALLBACK_FINISH' | translate,
						},
					]"
					formControlName="fallback"
					[multiple]="false"
					requireSelection
				/>
			</tec-form-group>

			@if (fallback === 'manual') {
				<tec-form-group
					[label]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_FALLBACK_VALIDATION' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_FALLBACK_VALIDATION_DESCRIPTION' | translate"
				>
					<tec-toggle
						[options]="[
							{
								id: 'auto',
								label: 'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_AUTO' | translate,
								tooltip: 'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_AUTO_TOOLTIP' | translate,
							},
							{
								id: 'manual',
								label: 'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_MANUAL' | translate,
								tooltip: 'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS_MANUAL_TOOLTIP' | translate,
							},
						]"
						formControlName="fallback_validation"
						[multiple]="false"
						requireSelection
					/>
				</tec-form-group>

				@if (fallbackValidation === 'manual') {
					<tec-form-group
						[label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_EMAIL' | translate"
						[description]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_EMAIL_DESCRIPTION' | translate"
					>
						<tec-textarea
							formControlName="fallback_emails"
							placeholder="email@emaill.com, email@mail.com,"
						/>
					</tec-form-group>
				}
			}
		}
	</tec-tile>

	<!-- Configuración avanzada -->
	<app-workflow-form-advanced-collapse [expanded]="id">
		<div class="item-group">
			<tec-item
				[classes]="['item--outline']"
				[title]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
				[tagImage]="{ icon: 'icon-AI' }"
			>
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-switch formControlName="tutorial" size="sm" />
			</tec-item>
			<tec-item
				[classes]="['item--outline']"
				[title]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIES' | translate"
				[tagImage]="{ icon: 'icon-pending-check' }"
			>
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.NUM_TRIES_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-input
					type="number"
					formControlName="total_tries"
					[min]="1"
					[max]="4"
					[hasError]="reactiveFormService.hasError(group.get('total_tries'))"
				/>
			</tec-item>
		</div>
	</app-workflow-form-advanced-collapse>
</tec-tile>
